import { data } from 'currency-codes';
import { startCase } from 'lodash';

//  these currencies are not supported by the backend yet
const filterList = [
  'XAG',
  'XAU',
  'XXX',
  'XTS',
  'XBA',
  'XBB',
  'XBC',
  'XBD',
  'XPD',
  'XPT',
  'XDR',
  'XSU',
  'XUA',
];

export const CURRENCIES = [
  { label: 'None', value: 'none' },
  ...data
    .map(currency => ({
      label: `${currency.code} (${startCase(currency.currency)})`,
      value: currency.code,
    }))
    .filter(currency => !filterList.includes(currency.value)),
];

export const getUserCurrency = (currencyCode: string) => {
  const foundUserCurrency = CURRENCIES.find(
    currency => currency.value === currencyCode
  );
  return (
    foundUserCurrency ?? {
      label: currencyCode,
      value: currencyCode,
    }
  );
};
